import React, { useState, useEffect } from "react";
import MainLayout from "./MainLayout";
import RegisterLayout from "./RegisterLayout";
import { CookiesPolicyProvider } from "contexts/CookiesPolicyContext";
import useLayout from "../../hooks/useLayout";
import { useLocation } from "react-router-dom";
import { ROLES } from "hooks/useGetRole";
import VerificationNewUserData from "components/pages/verificationNewUserData/VerificationNewUserData";
import { sessionDebugLog } from "utils/sessionExpirationUtils";

export interface LayoutProps {
  children: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { userRole, rolePermision, isImpersonation } = useLayout();
  const location = useLocation();

  const [afiliacionPendiente, setAfiliacionPendiente] = useState(
    localStorage.getItem("afiliacion_pendiente") === "true"
  );
  const impersonation = isImpersonation();
  const routeSection = location.pathname.split("/")[1];
  const roleIsSupported =
    userRole === ROLES.PACIENTE || userRole === ROLES.AUTONOMO;
  const layoutBranch = afiliacionPendiente
    ? "pending-affiliation"
    : routeSection === "politica-de-cookies"
      ? "cookies-policy"
      : typeof userRole !== "string"
        ? "no-role"
        : impersonation
          ? "impersonation"
          : roleIsSupported
            ? "patient"
            : "unsupported-role";

  useEffect(() => {
    sessionDebugLog("layout branch", {
      path: location.pathname,
      branch: layoutBranch,
      userRole,
      rolePermision,
      rolePermissionReady: rolePermision === userRole,
      isImpersonation: impersonation,
      afiliacionPendiente,
    });
  }, [
    location.pathname,
    layoutBranch,
    userRole,
    rolePermision,
    impersonation,
    afiliacionPendiente,
  ]);

  useEffect(() => {
    const handleChange = () => {
      setAfiliacionPendiente(localStorage.getItem("afiliacion_pendiente") === "true");
    };
    window.addEventListener("storage", handleChange);
    window.addEventListener("afiliacion_pendiente_changed", handleChange);
    return () => {
      window.removeEventListener("storage", handleChange);
      window.removeEventListener("afiliacion_pendiente_changed", handleChange);
    };
  }, []);

  if (afiliacionPendiente) {
    return <VerificationNewUserData />;
  }

  switch (routeSection) {
    case "politica-de-cookies":
      return <RegisterLayout>{children}</RegisterLayout>;
    default:
      if (typeof userRole === "string") {
        if (isImpersonation()) {
          return (
            <MainLayout> {children}</MainLayout>
          )
        }
        else {
          if (rolePermision === ROLES.PACIENTE || rolePermision === ROLES.AUTONOMO) {
            return (
              <CookiesPolicyProvider>
                <MainLayout>{children}</MainLayout>
              </CookiesPolicyProvider>
            );
          }
          else {
            return (
              <CookiesPolicyProvider>
                <MainLayout>{children}</MainLayout>
              </CookiesPolicyProvider>
            );
          }
        }
      } else {
        return (
          <CookiesPolicyProvider>
            <MainLayout>{children}</MainLayout>
          </CookiesPolicyProvider>
        );
      }
  }
};

export default Layout;
